import React from 'react';
import {
  RefreshCw, Clapperboard, CalendarClock, Mail, Target, Link2, Video, Globe,
  Smartphone, Radio, Zap, MessageSquare, BarChart3, HelpCircle, Gift,
  ClipboardList, Tag, CreditCard, Lock, Repeat, Ticket, Handshake, BookOpen,
  TrendingUp, Users, TrendingDown, Search, Palette, Mic, Bot, Microscope,
  RadioTower, Tv, CircleDollarSign, Timer, Sparkles, Headphones, Plug,
  GraduationCap, Briefcase, Building2, PartyPopper, Wand2, FileText, Megaphone,
  Music, ScrollText, Eye, Lightbulb, Save, Monitor, Image as ImageIcon, Rocket,
  Sprout, Coffee, Camera, SlidersVertical, SlidersHorizontal, Circle,
  Check, CheckCircle2, ArrowRight,
} from 'lucide-react';

// Maps the emoji used across the marketing/feature pages to a consistent Lucide
// line icon, so pages render premium single-color icons instead of multi-color
// emoji (which render differently per-OS and clash with the brand).
// Keys are emoji with variation selectors (U+FE0F) stripped — see normalize below.
const ICONS = {
  '🔄': RefreshCw, '🎬': Clapperboard, '📅': CalendarClock, '📧': Mail,
  '🎯': Target, '🔗': Link2, '📹': Video, '🌐': Globe, '📱': Smartphone,
  '🔴': Radio, '⚡': Zap, '💬': MessageSquare, '📊': BarChart3, '❓': HelpCircle,
  '🎁': Gift, '📋': ClipboardList, '🏷': Tag, '💳': CreditCard, '🔒': Lock,
  '🔁': Repeat, '🎟': Ticket, '🤝': Handshake, '📚': BookOpen, '📈': TrendingUp,
  '👥': Users, '📉': TrendingDown, '🔍': Search, '🎨': Palette, '🎙': Mic,
  '🤖': Bot, '🔬': Microscope, '📡': RadioTower, '🎥': Video, '📺': Tv,
  '💰': CircleDollarSign, '⏱': Timer, '🎧': Headphones, '🔌': Plug,
  '🎓': GraduationCap, '💼': Briefcase, '🏢': Building2, '🎪': PartyPopper,
  '🪄': Wand2, '📝': FileText, '📢': Megaphone, '🎵': Music, '📜': ScrollText,
  '👁': Eye, '💡': Lightbulb, '💾': Save, '🖥': Monitor, '🖼': ImageIcon,
  '🚀': Rocket, '🌱': Sprout, '☕': Coffee, '📷': Camera, '📲': Smartphone,
  '🎚': SlidersVertical, '🎛': SlidersHorizontal, '⏺': Circle,
  '✓': Check, '✅': CheckCircle2, '→': ArrowRight,
};

export default function FeatureIcon({ name, className = '', strokeWidth = 1.75 }) {
  const key = (name || '').replace(/️/g, ''); // strip emoji variation selectors
  const Icon = ICONS[key] || Sparkles;
  return <Icon className={className} strokeWidth={strokeWidth} aria-hidden="true" />;
}
